import React from 'react';
import NotamGrid from './NotamGrid';
const Notam = () => {

    return (
        <div className="notam-page">
            {/* <div className="left-section">
                <FiltersData />
            </div> */}
            <div className="right-section">
                <NotamGrid />
            </div>
        </div>
    );
};

export default Notam;
